<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 5; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="bluebtn main-container overflow-x-hidden">
      <div
        class="
          main-head-txt
          page-heading
          d-flex
          align-items-center
          justify-content-between
        "
      >
        <div class="pg-head">
          <span>User Management</span>
        </div>
        <div class="d-flex addpan" v-if="roles.includes('PUSH_PANEL')">
          <b-button @click="addpanelcontainer = true" class="mr-3">
            <img src="../../assets/panelist/plus_pan.svg" alt="" class="ml-2" />
            <span class="addpantxt mr-2">Panelist</span>
          </b-button>
        </div>
      </div>
      <div class="slectedpan-table-container py-3 relativeclass mt-3">
        <div class="d-flex align-items-center justify-content-between px-3">
          <div class="mr-3 page-head-txt">
            <span>Panelists</span>
          </div>

          <!-- <div class="search-bar mr-3">
            <img
              class="searchicon"
              src="../../assets/img/search-bar-icon.svg"
              alt=""
            />
            <b-form-input
              ref="search"
              class="search-input"
              type="search"
              v-model.trim="searchname"
              debounce="500"
              @update="
                currentPage = 1;
                getPanelPagination();
              "
              placeholder="Search Panelist"
            ></b-form-input>
          </div> -->
          <div>
            <div class="d-flex switchtext relativeclass">
              <div class="d-flex">
                <span class="sel-pan-len mr-3 pr-3 mt-1"
                  >Selected Panelist:&nbsp;{{ formattedSelectedLength }}</span
                >
              </div>
              <template v-if="allFilteredPanelDetails.length !== 0">
                <img
                  v-b-tooltip.hover.top="'Delete'"
                  v-if="roles.includes('DELETE_PANEL')"
                  @click="isEmpty ? '' : $bvModal.show('modal-delete')"
                  class="mr-3"
                  :class="isEmpty ? 'disableDeleteIcon' : 'pointer'"
                  src="../../assets/panelist/deletepan_btn.svg"
                  alt=""
                />
              </template>
              <div
                @click="showfiltercard = !showfiltercard"
                class="d-flex relativeclass addpan"
                v-closable="{
                  exclude: ['recdropdown', 'fildpd'],
                  handler: 'closefiltercard',
                }"
              >
                <b-button class="mr-3">
                  <img
                    src="../../assets/panelist/filter_pan.svg"
                    alt=""
                    class="ml-2"
                  />
                  <span class="addpantxt mr-2">Filter</span>
                </b-button>
                <div
                  class="mb-3 pointer"
                  style="position: absolute; top: 1px; left: 30px"
                  v-if="filtercount != 0"
                >
                  <img src="../../assets/panelist/fil_selected.svg" alt="" />
                </div>
              </div>
              <div v-if="showfiltercard" ref="recdropdown">
                <div
                  style="top: 36px; right: 18px; width: 300px; height: 213px"
                  class="panelist-filtercard d-flex align-items-center"
                >
                  <div>
                    <b-row>
                      <b-col>
                        <div
                          style="width: 270px"
                          class="aoeskl-field topDiv panellist-tags"
                          @click.stop=""
                        >
                          <label class="label-txt">Area Of Expertise</label>
                          <b-form-tags
                            class="text-truncate filter-input-pan"
                            id="input-1"
                            placeholder="e.g., Business, Finance"
                            v-model="areaofexp"
                            :tag-validator="tagValidatorareaofExpertise"
                            remove-on-delete
                          >
                          </b-form-tags>
                          <div>
                            <span class="hint-txt"
                              >Press "Enter" to add expertise</span
                            >
                          </div>
                        </div>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col>
                        <div
                          class="aoeskl-field topDiv mt-3 panellist-tags mb-2"
                          style="width: 270px"
                          @click.stop=""
                        >
                          <label class="label-txt">Skills</label>
                          <b-form-tags
                            class="text-truncate filter-input-pan"
                            id="input-1"
                            :tag-validator="tagValidatorskill"
                            placeholder="e.g., Java, Python"
                            v-model="sourceof"
                            remove-on-delete
                          ></b-form-tags>
                          <div>
                            <span class="hint-txt"
                              >Press "Enter" to add skills</span
                            >
                          </div>
                        </div>
                      </b-col>
                    </b-row>

                    <div
                      class="
                        d-flex
                        justify-content-between
                        align-items-center
                        mt-3
                      "
                    >
                      <div class="reset-btn">
                        <b-button class="" @click="showfiltercard = false">
                          Cancel
                        </b-button>
                      </div>

                      <div class="d-flex">
                        <div class="reset-btn">
                          <b-button
                            class=""
                            :disabled="
                              sourceof.length == 0 &&
                              areaofexp.length == 0 &&
                              filtercount === 0
                            "
                            @click="clearfilter()"
                          >
                            Reset
                          </b-button>
                        </div>
                        <div class="reset-btn ml-2">
                          <b-button
                            class="pointer"
                            :disabled="
                              sourceof.length == 0 && areaofexp.length == 0
                            "
                            @click="applyFilterCard()"
                          >
                            Apply
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="mb-1" />
        <!-- new panelists table design starts from here -->
        <div class="panelist-main-table mr-2 px-0 py-0">
          <div class="panelist-table-head mx-3 check-sel">
            <div
              v-if="roles.includes('DELETE_PANEL')"
              class="text-center panel-check"
              style="width: 5%"
            >
              <b-form-checkbox
                v-if="
                  allFilteredPanelDetails.length !== 0 &&
                  roles.includes('DELETE_PANEL')
                "
                name="checkbox-1"
                v-model="allSelected"
                @change="selectAllPanelist"
              >
              </b-form-checkbox>
            </div>
            <div style="width: 15%" class="text-left">
              <span class="pl-2 mr-2">Panelist Name</span>
              <template v-if="statusValue == 'name'">
                <img
                  @click="sort('name', false)"
                  v-if="sortByValue === true"
                  class="pointer img-h"
                  src="../../assets/panelist/up_sort.svg"
                  alt=""
                />
                <img
                  v-if="!sortByValue"
                  @click="sort('name', true)"
                  class="pointer img-h"
                  src="../../assets/panelist/down_sort.svg"
                  alt=""
                />
              </template>
              <img
                v-else
                @click="sort('name', true)"
                class="pointer img-h"
                src="../../assets/panelist/no_sort.svg"
                alt=""
              />
            </div>
            <div style="width: 15%" class="text-left">
              <span>Email ID</span>
              <template v-if="statusValue == 'email'">
                <img
                  @click="sort('email', false)"
                  v-if="sortByValue === true"
                  class="pointer ml-1 img-h"
                  src="../../assets/panelist/up_sort.svg"
                  alt=""
                />
                <img
                  v-if="!sortByValue"
                  @click="sort('email', true)"
                  class="pointer ml-1 img-h"
                  src="../../assets/panelist/down_sort.svg"
                  alt=""
                />
              </template>
              <img
                v-else
                @click="sort('email', true)"
                class="pointer ml-1 img-h"
                src="../../assets/panelist/no_sort.svg"
                alt=""
              />
            </div>
            <div style="width: 15%" class="text-left">
              <span>Contact Number</span>
            </div>
            <div style="width: 20%" class="text-left">
              <span>Area of Expertise</span>
            </div>
            <div style="width: 20%" class="text-left pr-4">
              <span>Skills</span>
            </div>

            <div
              v-if="roles.includes('PUT_PANEL')"
              style="width: 10%"
              class="text-left"
            >
              <span>Action</span>
            </div>
          </div>
          <div class="panelist-table-body px-3">
            <div
              v-if="!LoaderStatus && allFilteredPanelDetails.length == 0"
              class="
                d-flex
                flex-column
                align-items-center
                justify-content-center
              "
              style="height: calc(-304px + 92vh)"
            >
              <div
                v-if="allFilteredPanelDetails.length === 0 && searchQuery == ''"
              >
                <div>
                  <img
                    src="../../assets/img/accessconnew/emptyprivilageBig.svg"
                    alt=""
                  />
                </div>
                <div class="mt-2 text-center access-font-color">
                  No records found.
                </div>
              </div>

              <div
                class="
                  h-75
                  d-flex
                  flex-column
                  align-items-center
                  justify-content-center
                "
                v-else-if="
                  allFilteredPanelDetails.length === 0 &&
                  searchQuery !== '' &&
                  !LoaderStatus &&
                  searchQuery != 'Loader'
                "
              >
                <div>
                  <img
                    src="../../assets/img/accessconnew/emptyprivilageBig.svg"
                    alt=""
                  />
                </div>
                <div class="mt-2 text-center access-font-color">
                  No matching results for &nbsp;
                  <span class="access-font-color-b text-center"
                    >"{{ searchQuery }}"</span
                  >.
                </div>
              </div>
            </div>
            <div v-else>
              <div
                class="new-panelist-table-row check-sel"
                v-for="(pan, index) in allFilteredPanelDetails"
                :key="index"
              >
                <div class="panelistcolorDynamic mr-1"></div>

                <div
                  v-if="roles.includes('DELETE_PANEL')"
                  style="width: 5%"
                  class="text-center relativeclass panel-check"
                >
                  <template>
                    <b-form-checkbox
                      name="checkbox-2"
                      style="bottom: 3px"
                      :value="pan.panelID"
                      v-model="panellistSelected"
                      @change="deselect"
                      :disabled="!pan.active"
                    >
                    </b-form-checkbox>
                  </template>
                </div>
                <div class="relativeclass text-left" style="width: 15%">
                  <div
                    v-if="!roles.includes('DELETE_PANEL')"
                    class="panelistcolorDynamic mr-1"
                  ></div>
                  <div class="pl-2 text-truncate">
                    <span
                      v-if="panelistStatus == ''"
                      v-b-tooltip.hover.top="pan.name"
                      style="max-width: 100%"
                      class="d-inline-block record-txt text-truncate"
                      >{{ pan.name }}</span
                    >
                    <span
                      v-else
                      style="max-width: 100%"
                      class="d-inline-block record-txt text-truncate"
                      >{{ pan.name }}</span
                    >
                  </div>
                </div>
                <div
                  v-if="panelistStatus == ''"
                  v-b-tooltip.hover.top="pan.email"
                  style="width: 15%"
                  class="text-left"
                >
                  <div
                    style="max-width: 100%"
                    class="d-inline-block record-txt text-truncate"
                  >
                    {{ pan.email }}
                  </div>
                </div>
                <div v-else style="width: 15%" class="text-left">
                  <div
                    style="max-width: 100%"
                    class="d-inline-block record-txt text-truncate"
                  >
                    {{ pan.email }}
                  </div>
                </div>
                <div style="width: 15%" class="record-txt text-left">
                  {{ pan.phoneNumber }}
                </div>
                <div style="width: 20%" class="text-left">
                  <div class="text-truncate">
                    <span
                      class="d-inline-block record-txt text-truncate"
                      style="max-width: 100%"
                      :id="'jo' + pan.panelID"
                    >
                      {{ pan.areaOfExpertise | fnName }}</span
                    >
                  </div>
                  <div>
                    <b-popover
                      v-if="panelistStatus == ''"
                      :target="'jo' + pan.panelID"
                      triggers="hover"
                      placement="top"
                    >
                      <span
                        v-for="(jo, index) in pan.areaOfExpertise"
                        :key="jo.id"
                      >
                        {{ jo.name }}
                        <span v-if="index !== pan.areaOfExpertise.length - 1"
                          >,</span
                        >
                      </span>
                    </b-popover>
                    <b-popover
                      v-else
                      :target="'jo' + pan.panelID"
                      placement="top"
                    >
                      <span
                        v-for="(jo, index) in pan.areaOfExpertise"
                        :key="jo.id"
                      >
                        {{ jo.name }}
                        <span v-if="index !== pan.areaOfExpertise.length - 1"
                          >,</span
                        >
                      </span>
                    </b-popover>
                  </div>
                </div>
                <div style="width: 20%" class="text-left">
                  <div class="text-truncate">
                    <span
                      class="d-inline-block record-txt text-truncate"
                      style="width: fit-content"
                      :id="'tp' + pan.panelID"
                    >
                      {{ pan.skills | fnName }}</span
                    >
                  </div>
                  <div>
                    <b-popover
                      v-if="panelistStatus == ''"
                      :target="'tp' + pan.panelID"
                      triggers="hover"
                      placement="top"
                    >
                      <span v-for="(me, index) in pan.skills" :key="me.id">
                        {{ me.name }}
                        <span v-if="index !== pan.skills.length - 1">,</span>
                      </span>
                    </b-popover>
                    <b-popover
                      v-else
                      :target="'tp' + pan.panelID"
                      placement="top"
                    >
                      <span v-for="(me, index) in pan.skills" :key="me.id">
                        {{ me.name }}
                        <span v-if="index !== pan.skills.length - 1">,</span>
                      </span>
                    </b-popover>
                  </div>
                </div>

                <div
                  style="width: 10%; bottom: 3px"
                  v-if="roles.includes('PUT_PANEL')"
                  class="text-left relativeclass pl-3"
                >
                  <img
                    v-b-tooltip.hover.top="'Edit'"
                    src="../../assets/panelist/blue_pencil.svg"
                    class="pointer"
                    alt=""
                    @click="gotoeditpanel(pan)"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            class="
              panelist-admin-paginaTion-new
              d-flex
              justify-content-between
              align-items-center
              mx-3
            "
          >
            <div class="d-flex">
              <span class="qb-gotopage-text p-2">Go to page</span>
              <b-form-input
                type="text"
                class="qb-pagination-num ml-2 mt-1"
                v-model="goToPage"
                @keyup.enter="
                  goToPage === null || goToPage == '' || iscontainsNumber
                    ? goToPages(goToPage)
                    : ''
                "
                @keypress="NumbersOnly"
                @paste="handlePaste"
              ></b-form-input>

              <span
                @click="
                  goToPage === null || goToPage == '' || !iscontainsNumber
                    ? ''
                    : goToPages(goToPage)
                "
                :class="
                  goToPage === null || goToPage == '' || !iscontainsNumber
                    ? 'disableDeleteIcon pl-3 mt-1'
                    : 'pointer pl-3 mt-1'
                "
                ><img src="../../assets/panelist/page_arrow.svg" alt=""
              /></span>
            </div>
            <div class="pagination">
              <b-pagination
                class="page_text"
                v-model.number="currentPage"
                @input="getPanelPagination(), (goToPage = null)"
                :total-rows="total"
                :per-page="pageCount"
                align="center"
                first-number
                last-number
              >
                <template #prev-text
                  ><span
                    ><img
                      src="../../assets/panelist/page_left.svg"
                      alt=""
                    /> </span
                ></template>
                <template #next-text
                  ><span
                    ><img
                      src="../../assets/panelist/page_right.svg"
                      alt="" /></span
                ></template>
              </b-pagination>
            </div>
            <div class="d-flex align-items-center">
              <PageInput :pagecount="pageCount" @update-value="updatePage" />
              <div class="qb-gotopage-text mr-2 ml-4">
                Showing : <span v-if="pageStart > total">0</span
                ><span v-else>{{ pageStart }}</span> - {{ pageEnd }}
                <span class="pl-1"></span> of <span class="pr-1"></span
                >{{ total }}
              </div>
            </div>
          </div>
        </div>

        <!-- table ends -->
      </div>

      <!--delete modal starts -->
      <b-modal
        class="delmodal"
        id="modal-delete"
        centered
        hide-footer
        hide-header
      >
        <div class="pr-4">
          <div class="d-flex testconfig-card-name">
            <div style="height: 48px">
              <img src="../../assets/panelist/red_del_icon.svg" />
            </div>
            <div>
              <div class="label-txt-del">Delete Panelist</div>
              <div class="modal-txt-del">
                This Panelist along with all tagged jobs will also be removed
              </div>
            </div>
            <div
              class="rotate-on-hover pointer"
              @click="$bvModal.hide('modal-delete')"
              style="position: absolute; top: 16px; right: 26px"
            >
              <img
                style="height: 12px"
                src="../../assets/panelist/blue_cross.svg"
                alt=""
              />
            </div>
          </div>

          <div class="d-flex align-items-center justify-content-end mt-3">
            <div class="cancelpan-btn mr-3">
              <b-button
                @click="$bvModal.hide('modal-delete')"
                style="width: 120%"
                >Cancel</b-button
              >
            </div>
            <div class="ml-3 addpan">
              <b-button
                @click="deletepanelist()"
                style="font-size: small; width: 120%"
                >Delete</b-button
              >
            </div>
          </div>
        </div>
      </b-modal>
      <!--delete modal ends -->

      <!-- *****************   Add Panelist Container   ******************************* -->
      <Transition name="slide">
        <div class="addeval-half-container" v-if="addpanelcontainer">
          <div
            class="d-flex align-items-center justify-content-between pt-3 pl-2"
          >
            <div
              @click="addpanelcontainer = false"
              class="position-absolute pointer swp-backArrow"
            >
              <img src="../../assets/panelist/transition_arrow.svg" alt="" />
            </div>
            <div class="head-txt ml-3 mt-2 pl-3">Add Panelist</div>
            <div class="d-flex align-items-center">
              <div
                style="position: absolute; top: 20px; right: 20px"
                @click="addpanelcontainer = false"
                class="rotate-on-hover pointer"
              >
                <img
                  v-b-tooltip.hover.top="'Close'"
                  src="../../assets/panelist/blue_cross.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <hr class="mx-3 mb-2" />
          <AddPanel
            @onAddPanelist="handleAddPanel"
            @paneladd="LoaderStatus = true"
            @cancelPan="closePan"
            @failure="LoaderStatus = false"
          />
        </div>
      </Transition>

      <!-- *****************  End  Panelist  Container ******************************* -->

      <!-- *****************   Edit Panelist Container   ******************************* -->
      <Transition name="slide">
        <div class="addeval-half-container" v-if="editpanelcontainer">
          <div
            class="d-flex align-items-center justify-content-between pt-3 pl-2"
          >
            <div
              @click="(editpanelcontainer = false), resetStatus()"
              class="position-absolute pointer swp-backArrow"
            >
              <img src="../../assets/panelist/transition_arrow.svg" alt="" />
            </div>
            <div class="head-txt ml-3 mt-2 pl-3">Edit Panelist</div>
            <div class="d-flex align-items-center">
              <div
                @click="(editpanelcontainer = false), resetStatus()"
                style="position: absolute; top: 20px; right: 20px"
                class="rotate-on-hover pointer"
              >
                <img
                  v-b-tooltip.hover.top="'Close'"
                  src="../../assets/panelist/blue_cross.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
          <hr class="mx-3 mb-2" />
          <EditPanel
            :panelistdata="panelistdata"
            @onEditPanelist="handleEditPanel"
            @paneladd="LoaderStatus = true"
            @cancelPan="closePan"
            @failure="LoaderStatus = false"
          />
        </div>
      </Transition>

      <!-- *****************  End Edit Panelist  Container ******************************* -->
    </div>
    <b-modal
      id="confirmActiveDeactive"
      centered
      hide-footer
      hide-header
      class="qb-add-ques-modal"
      @hidden="$bvModal.hide('confirmActiveDeactive')"
    >
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        Caution !
      </div>
      <div
        @click="$bvModal.hide('confirmActiveDeactive')"
        class="xMarkCancel pointer"
      >
        <img src="../../assets/xmark.svg" alt="" />
      </div>
      <hr />
      <div class="mt-3 testconfig-card-name">
        <span class="cj-breakword">{{ panelistStatusMessage }}</span>
      </div>

      <div class="d-flex align-items-center justify-content-end mt-3">
        <b-button class="addbtn mr-2" @click="deactivatepan(panelDetails)">
          {{ panelDetails.active ? "Deactivate" : "Activate" }}
        </b-button>
        <div
          class="cancelbtntext pointer"
          @click="$bvModal.hide('confirmActiveDeactive')"
        >
          Cancel
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import toast from "../../components/mixin/toast";
import {
  getPanelPagination,
  putpanel,
  deletePanel,
} from "../../utils/apiFunctions";
import PageInput from "../../components/InputComponents/PaginationInput.vue";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import AddPanel from "../../views/panel/AddPanel.vue";
import EditPanel from "../../views/panel/EditPanel.vue";
import { NumbersOnly } from "../../controllers/Candidate/helpers";
import commonFunc from "../../components/mixin/commonFunctions.js";
export default {
  name: "Panellist",
  components: {
    Spinner,
    AddPanel,
    EditPanel,
    PageInput,
  },
  mixins: [toast, commonFunc],
  data() {
    return {
      // BOOLEANS
      editpanelcontainer: false,
      addpanelcontainer: false,
      showfiltercard: false,
      allSelected: false,
      filter: false,
      sortByValue: false,
      LoaderStatus: false,
      openType: false,

      // NUMBERS
      filtercount: 0,
      total: 0,
      currentPage: 1,
      pageCount: 10,
      timer: null,
      goToPage: null,
      optionselected: null,

      // STRINGS
      panelistStatus: "",
      nxtpg: "0",
      prevpg: "",
      pageStart: "",
      pageEnd: "",
      searchemail: "",
      searchname: "",
      searchskills: "",
      searchaofe: "",
      searchphno: "",
      selectedType: "",
      statusValue: "createdAt",

      // ARRAYS
      sourceof: [],
      areaofexp: [],
      skillsfil: [],
      aoesfil: [],
      delpanel: [],
      panellistSelected: [],
      allFilteredPanelDetails: [],
      options: [
        { text: "Active", value: true },
        { text: "Inactive", value: false },
      ],
      typeOptions: [
        { text: "All", value: 0 },
        { text: "Active", value: 1 },
        { text: "Inactive", value: 2 },
      ],

      // OBJECTS
      panelistdata: {},
      panelDetails: {},
    };
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue != "Loader") {
          this.getPanelPagination();
        }
      }
    },
  },
  computed: {
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
    ...mapGetters(["roles"]),
    isEmpty: ({ panellistSelected }) => panellistSelected.length === 0,
    totalPages() {
      return Math.ceil(this.total / this.pageCount);
    },
    // To check if it does not contain an alphabet or zero
    iscontainsNumber() {
      return /^[1-9]\d*$/.test(this.goToPage);
    },
    panelistStatusMessage() {
      if (this.panelDetails.active) {
        return "This panelist is active. Are you sure you want to make the panelist inactive?";
      } else {
        return "This panelist is inactive. Are you sure you want to make the panelist active?";
      }
    },
    formattedSelectedLength() {
      return this.panellistSelected.length < 10
        ? "0" + this.panellistSelected.length
        : this.panellistSelected.length;
    },
  },

  created() {
    this.getPanelPagination();
    this.$store.commit("searchVUEX/saveSearchQuery", "");
  },
  filters: {
    fnName(value) {
      const ellipsis = value.length > 3 ? "..." : "";
      return value.length
        ? value
            .slice(0, 3)
            .map((item) => item.name)
            .join(", ") + ellipsis
        : "";
    },
  },
  methods: {
    // Method to validate skill tags
    tagValidatorskill(tag) {
      let skill_list = this.sourceof.map((s) => s.toLowerCase());
      return !skill_list.includes(tag.toLowerCase());
    },

    tagValidatorareaofExpertise(tag) {
      let skill_list = this.areaofexp.map((s) => s.toLowerCase());
      return !skill_list.includes(tag.toLowerCase());
    },
    applyFilterCard() {
      this.statusValue = "";
      this.showfiltercard = false;
      this.filtercount = 0;
      if (this.sourceof.length != 0) {
        this.filtercount++;
      }
      if (this.areaofexp.length != 0) {
        this.filtercount++;
      }
      this.getPanelPagination();
    },
    handleCloseqbdropdiff(index) {
      return () => {
        this.allFilteredPanelDetails[index].view = false;
        this.$forceUpdate();
      };
    },
    NumbersOnly(evt) {
      NumbersOnly(evt);
    },
    handleAddPanel() {
      this.LoaderStatus = false;
      this.addpanelcontainer = false;
      this.getPanelPagination();
    },
    // close the edit container and update the data on screen
    handleEditPanel() {
      this.LoaderStatus = false;
      this.editpanelcontainer = false;
      this.getPanelPagination();
    },
    closePan() {
      this.addpanelcontainer = false;
      this.editpanelcontainer = false;
    },
    gotoeditpanel(data) {
      this.editpanelcontainer = true;
      this.panelistdata = { ...data };
      this.panelistStatus = "Edit";
    },
    resetStatus() {
      this.panelistStatus = "";
    },
    updatePage(value) {
      this.pageCount = value;
      this.currentPage = 1;
      this.getPanelPagination();
    },
    // Get all Panellist Api
    async getPanelPagination() {
      try {
        this.skillsfil = [...this.sourceof];
        this.aoesfil = [...this.areaofexp];
        this.LoaderStatus = true;
        let payload = {
          type: "1",
          count: this.pageCount,
          page: this.currentPage - 1,
          sortBy: {
            column: this.statusValue,
            order: this.sortByValue,
          },
          filters: {
            skillSets: this.sourceof,
            expertise: this.areaofexp,
          },
          searchQuery: this.searchQuery,
        };
        const res = await getPanelPagination(payload);
        if (res.status == 200) {
          this.LoaderStatus = false;
          this.allFilteredPanelDetails = res.data.data.data;
          this.allFilteredPanelDetails.forEach((obj) => {
            obj.view = false;
          });
          this.pageStart = res.data.data.pageStart;
          this.pageEnd = res.data.data.pageEnd;
          this.total = res.data.data.total;
          this.checkSelectAll();
        } else {
          this.LoaderStatus = false;
        }
      } catch (err) {
        this.LoaderStatus = false;
        this.errorModal("Something went wrong");
        throw err;
      }
    },
    sort(data, sortBool) {
      this.statusValue = data;
      this.sortByValue = sortBool;
      this.getPanelPagination();
    },
    // GO TO ANY PAGE
    goToPages(index) {
      this.currentPage = Math.min(Math.max(1, index), this.totalPages);
      this.goToPage = null;
      this.getPanelPagination();
    },
    selectAllPanelist() {
      if (this.allSelected) {
        for (let panel of this.allFilteredPanelDetails) {
          if (
            (panel.active || panel.active === null) &&
            !this.panellistSelected.includes(panel.panelID)
          ) {
            this.panellistSelected.push(panel.panelID);
          }
        }
      } else {
        for (let panel of this.allFilteredPanelDetails) {
          if (panel.active || panel.active === null) {
            const index = this.panellistSelected.indexOf(panel.panelID);
            if (index !== -1) {
              this.panellistSelected.splice(index, 1);
            }
          }
        }
      }
    },
    deselect() {
      this.allSelected = false;
      const containsAll = this.allFilteredPanelDetails.every((element) => {
        return this.panellistSelected.includes(element.panelID);
      });
      if (containsAll) {
        this.allSelected = true;
      }
    },
    changeActive(index) {
      // Close all other panels
      this.allFilteredPanelDetails.forEach((panel, i) => {
        if (i !== index) {
          panel.view = false;
        }
      });
      this.optionselected = this.allFilteredPanelDetails[index].active;
      this.allFilteredPanelDetails[index].view =
        !this.allFilteredPanelDetails[index].view;

      this.$forceUpdate();
    },

    checkSelectAll() {
      let isSelectedAll = true;

      if (this.allFilteredPanelDetails.length !== 0) {
        for (const record of this.allFilteredPanelDetails) {
          if (
            this.panellistSelected.filter((value) => value == record.panelID)
              .length === 0
          ) {
            isSelectedAll = false;
            break;
          }
        }
      } else {
        isSelectedAll = false;
      }

      this.allSelected = isSelectedAll;
    },
    async deletepanelist() {
      try {
        if (!this.isEmpty) {
          let payload = {
            panelID: this.panellistSelected,
          };
          const res = await deletePanel(payload);
          if (res.status == 200) {
            if (this.panellistSelected.length > 1) {
              this.successModal(
                this.panellistSelected.length +
                  " Panelists deleted successfully!"
              );
            } else {
              this.successModal(
                this.panellistSelected.length +
                  " Panelist deleted successfully!"
              );
            }
            this.panellistSelected = [];
            this.getPanelPagination();
          } else {
            this.errorModal("Something went wrong!");
          }
        } else {
          alert("No panelist is selected");
        }
        this.$bvModal.hide("modal-delete");
      } catch (err) {
        this.errorModal("Something went wrong!");
        throw err;
      }
    },
    editpanel(panelID) {
      this.$router.push({ path: `editpanel/${panelID}` });
    },
    async deactivatepan(panel) {
      try {
        const paneldata = {
          name: panel.name,
          phoneNumber: panel.phoneNumber,
          email: panel.email,
          skills: panel.skills,
          areaOfExpertise: panel.areaOfExpertise,
          panelID: panel.panelID,
          active: this.optionselected,
        };
        const res = await putpanel(paneldata);
        if (res.status === 200) {
          this.successModal("Panelist updated successfully");
          this.getPanelPagination();
          this.$bvModal.hide("confirmActiveDeactive");
        }
        panel.view = false;
      } catch (error) {
        console.error(error);
      }
    },
    activatepan(pan) {
      this.panelDetails = pan;
      this.$bvModal.show("confirmActiveDeactive");
    },
    clearfilter() {
      this.sourceof = [];
      this.areaofexp = [];
      this.showfiltercard = false;
      if (this.filtercount != 0) {
        this.statusValue = "";
        this.getPanelPagination();
      }
      this.filtercount = 0;
      this.showfiltercard = false;
    },
    //to close filter card after clicking outside
    closefiltercard() {
      this.sourceof = [...this.skillsfil];
      this.areaofexp = [...this.aoesfil];
      this.showfiltercard = false;
    },
  },
};
</script>

<style>
.topDiv > .tagsinputField {
  padding: 10px;
  border: 1px solid var(--input-border);
  border-radius: 3px !important;
  font-size: var(--size-12);
  font-weight: var(--weight-LM);
  line-height: 18px;
  z-index: 5;
  background: var(--bg-inputfield);
}

.swp-backArrow {
  top: 2px;
  left: -29px;
}
.swp-group-main-heading {
  font-weight: 600;
  font-size: 18px;
  color: #464667;
}

.addeval-half-container {
  position: absolute;
  width: 700px;
  height: calc(100vh - 86px);
  right: 0;
  top: 5px;
  z-index: 4;
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
  border-radius: 8px;
}

/* transition for sliding */
.slide-leave-active,
.slide-enter-active {
  transition: 0.5s;
}

.slide-enter {
  transform: translate(100%, 0);
}

.slide-leave-to {
  transform: translate(100%, 0);
}

/* eo transition */

.qb-filter-count {
  width: 19px;
  background: #ff7e47;
  border-radius: 10px;
  height: 19px;
  text-align: center;
  bottom: -5px;
  font-weight: var(--weight-B);
  font-size: var(--size-10);
  padding-top: 2px;
  position: absolute;
  margin-left: 19px;
}
.panelistcolorDynamic {
  position: absolute;
  border-radius: 2px 1px 1px 2px;
  width: 3px;
  height: 90%;
  margin: auto;
  background: #20639b;
  top: 2px;
  left: 3px;
}
.disableDeleteIcon {
  opacity: 0.6;
  cursor: initial;
}
.panel-list-parentdiv {
  position: relative;
  height: calc(100vh - 70px);
  top: 70px;
  padding-left: 80px;
  overflow-x: hidden;
  padding-right: 15px;
}

.ac-inputField {
  min-height: auto !important;
  max-height: 150px !important;
  overflow: auto;
}

.reqd_add_1 .b-form-tags-list .btn {
  margin-right: 25px;
  display: none;
}

.reqd_add_2 .b-form-tags-list .btn {
  margin-right: 0px;
  display: none;
}

/* new design for table */
.panelist-main-table {
  max-width: 100%;
  /* min-width: 1000px; */
  position: relative;
  height: calc(100vh - 238px);
  /* overflow-x: auto;
  overflow-y: hidden; */
}

.panelist-table-head {
  max-width: 100%;
  /* min-width: 1000px; */
  background: #e9f0f5;
  border-radius: 3px;
  display: flex;
  align-items: center;
  padding: 15px 0px;
  font-weight: 600;
  font-size: 14px;
  color: #20639b;
  font-family: "Lato", sans-serif;
}

.panelist-table-body {
  width: calc(100% + 5px);
  overflow-y: auto;
  height: calc(100vh - 355px);
}

.panelist-table-row {
  width: 100%;
  position: relative;
  border-radius: 3px;
  border: 0.5px solid #e5e5e5;
  background: #fafafa;
  box-shadow: 0px 4px 12px 0px rgba(196, 196, 196, 0.5);
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 13px;
  color: #696969;
  padding: 15px 0px;
  margin: 10px 0px;
}

.panelist-table-row:hover {
  background: #e7e8f5;
}
.cpn-drop-modal {
  position: absolute;
  top: 33px;
  z-index: 3;
  border-radius: 7px;
  background: #fff;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
  width: 115px;
  border: unset;
}
.cpn-inactive {
  border-radius: 25px;
  background: #f8bdbd;
  color: var(--cv-red);
  font-size: var(--size-13);
  font-weight: var(--weight-R);
  width: 117px;
  padding: 5px 0px;
}
.cpn-active {
  border-radius: 25px;
  background: #ffe7b6;
  color: #ff7f00;
  font-size: var(--size-13);
  font-weight: var(--weight-R);
  width: 117px;
  padding: 5px 0px;
}

.cpn-drop-modal .btn-secondary:first-child {
  color: #696969;
  background-color: #fff;
  border: none;
}

.cpn-drop-modal .btn-secondary:last-child {
  background: #e7e7e7;
  color: #545454;
  border: none;
}

.ac-inputField .text-muted {
  color: #dc3545 !important;
}
.pg-head {
  width: 180px;
  height: 26px;
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 130%;
  /* identical to box height, or 26px */
  color: #20639b;
}
.addpan .btn-secondary {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 12px 5px 12px;
  gap: 10px;

  /* position: absolute;
left: 87.22%;
right: 3.33%;
top: 10.92%;
bottom: 85.22%; */

  background: #20639b;
  border-radius: 40px;
}
.addpantxt {
  font-family: "Montserrat", sans-serif, sans-serif;
  font-weight: 600;
  font-size: 13px;
  /* identical to box height */
  display: flex;
  align-items: center;

  color: #ffffff;
}
.sel-pan-len {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 15px;
  /* identical to box height */

  color: #20639b;
}
.active-txt {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  /* identical to box height */

  color: #038e00;
}
.inactive-txt {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  /* identical to box height */

  color: #e70016;
}
.qb-gotopage-text {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 12px;
  /* identical to box height */

  color: #20639b;
}
.page_text .page-link {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;

  color: #20639b;
}
.page_text .page-item.active .page-link {
  width: 19.86px;
  height: 20px;
  color: #ffffff;
  padding: 3px;
  background: #20639b;
  border-radius: 3px;
}

.qb-pagination-num {
  width: 39.72px;
  height: 23px;
  font-size: 12px;

  background: #ffffff;
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 5px;
}
.record-txt {
  width: 119px;
  height: 20px;

  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  /* identical to box height */

  color: #20639b;
}

.addpan .btn-secondary:hover {
  color: var(--bg-white);
  background-color: #20639b;
  box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
    2px 3px 7px 0px rgba(32, 99, 155, 0.2),
    7px 10px 12px 0px rgba(32, 99, 155, 0.17),
    44px 63px 22px 0px rgba(32, 99, 155, 0);
}
.addpan .btn-secondary:not(:disabled):not(.disabled):active,
.addpan .btn-secondary:not(:disabled):not(.disabled).active,
.addpan .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #20639b;
  border-color: #20639b;
}

.dpdfilter {
  position: absolute;
  z-index: 10;
  width: 240px;
  top: 59px;
}
.dpdradio {
  width: 100%;
}
.dpdradio .btn-secondary {
  background: #f9f9f9;
  color: #000;
  border: none;
  text-align: left;
  border-radius: 4px 4px 4px 4px;
}
.dpdradio .btn-secondary:not(:disabled):not(.disabled).active {
  color: #000;
  background-color: #e8eff4;
  border: none;
}
.label-txt-del {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 18px;
  margin-left: 5px;
  /* identical to box height, or 21px */
  padding: 5px;
  color: #000000;
}
.reset-btn .btn-secondary {
  background-color: #fff;
  font-family: "Montserrat", sans-serif;
  border: 1px solid #20639b;
  color: #20639b;
  border-radius: 40px;
  padding: 1px 12px 1px 12px;
  font-size: 11px;
  font-weight: 600;
}
.reset-btn .btn-secondary:disabled {
  color: #20639b;
  border: 1px solid #20639b !important;
  background-color: #fff;
  border-color: #20639b;
}
.reset-btn .btn-secondary:hover {
  color: #20639b;
  border-radius: 40px;
  background-color: #ffffff;
  font-weight: 600;
  font-family: "Montserrat", sans-serif;
  font-size: var(--size-11);
  box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
    2px 3px 7px 0px rgba(32, 99, 155, 0.2),
    7px 10px 12px 0px rgba(32, 99, 155, 0.17),
    44px 63px 22px 0px rgba(32, 99, 155, 0);
}
.cancelpan-btn .btn-secondary {
  background-color: #fff;

  border: 1px solid #20639b;
  color: #20639b;
  border-radius: 40px;
  font-size: 11px;
  font-weight: 600;
  font-family: "Montserrat", sans-serif;
}
.cancelpan-btn .btn-secondary:disabled {
  color: #20639b;
  border: 1px solid #20639b !important;
  background-color: #fff;
  border-color: #20639b;
}
.cancelpan-btn .btn-secondary:hover {
  color: #20639b;
  border: 1px solid #20639b !important;
  background-color: #fff;
  border-color: #20639b;
  box-shadow: 0px 0px 0px 0px rgba(32, 99, 155, 0.2),
    2px 3px 7px 0px rgba(32, 99, 155, 0.2),
    7px 10px 12px 0px rgba(32, 99, 155, 0.17),
    44px 63px 22px 0px rgba(32, 99, 155, 0);
}
.cancelpan-btn .btn-secondary:not(:disabled):not(.disabled):active,
.cancelpan-btn .btn-secondary:not(:disabled):not(.disabled).active,
.cancelpan-btn .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  border-color: #20639b;
  background-color: #20639b;
}
.head-txt {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  /* identical to box height, or 125% */

  /* Gray / 700 */
  color: #344054;
}
.slectedpan-table-container {
  background: #ffffff;
  border-radius: 8px;
  height: calc(100vh - 167px);
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
}

.check-sel .custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #20639b;
  background-color: #20639b;
}
.modal-txt-del {
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  /* identical to box height, or 162% */
  padding-left: 4px;
  margin-left: 5px;
  color: #344054;
}
.main-head-txt {
  background: #f6f9fb;
  border-radius: 8px;
  padding: 12px 20px;
}
.page-head-txt {
  font-family: "Lato", sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #000000;
}
.img-h {
  height: 13px;
  width: 10px;
}
.panelist-admin-paginaTion-new {
  background: #fcfcfc;
  /* min-width: 1000px; */
  max-width: 100%;
}
.page-item.active .page-link {
  text-decoration: none;
}
.access-font-color {
  font-size: 15px;
  font-weight: 500;
  color: #696969;
}

/* new panellist table design fixes starts */
.new-panelist-main-table {
  width: 100%;
  position: relative;
  height: calc(100vh - 245px);
  overflow-x: auto;
  overflow-y: hidden;
  padding: 10px;
}

.new-panelist-table-head {
  min-width: 1000px;
  max-width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #20639b;
  font-family: "lato", sans-serif;
  background: #20639b1a;
}

.new-panelist-table-body {
  min-width: 1000px;
  max-width: 100%;
  overflow-y: auto;
  height: calc(100vh - 350px);
}

.new-panelist-table-row {
  width: 100%;
  position: relative;
  border-radius: 3px;
  border: 0.5px solid #e5e5e5;
  background: #fcfcfc;
  box-shadow: 0px 4px 15px 0px #c4c4c480;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 15px;
  color: #20639b;
  font-family: "lato", sans-serif;
  padding: 15px 0px 15px 0px;
  margin: 10px 0px;
}

.new-panelist-table-row:hover {
  background: #e7e8f5;
}

.new-panelist-admin-paginaTion-new {
  min-width: 1000px;
  max-width: 100%;
  padding: 5px 10px;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 15%);
  border-radius: 0px 0px 5px 5px;
  background: #fcfcfc;
  z-index: 1;
}
.panel-check .custom-control-input {
  display: none !important;
}

/* new panellist table design fixes ends */
</style>
